<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<div class="main">
  <div class="wrap">
    <div class="sub-request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2 style="text-align: center">درخواست های معرفی نامه</h2>
            <h2 style="text-align: center">شماره بیمه نامه: {{insurance.insuranceNumber}}</h2>
          </div>
        </div>
      </div>
      <div class="row" *ngFor="let subset of insurance.subsetList; let last = last">
        <div class="col col-12">
          <app-details-div
            [rawCount]="3"
            [translation]="translation"
            [array]="subset.getDisplayArray()"
            [header]="subset.getFirstName() + ' ' + subset.getLastName()"
            [id]="subset.getFormID() || subset.getId()"
            (takeAction)="takeAction($event)"
            (secondaryClicked)="secondaryClicked(subset)"
            [mainLabel]="subset.getMaiLabel()"
            [backLabel]="subset.getSecondaryLabel()"
          ></app-details-div>
        </div>
      </div>
    </div>
  </div>
</div>


<app-custom-button
  [LabelText]="'افزودن بیمه گذار جدید'"
  [mode]="'BOTTOM'"
  [Show]="!insurance.locked"
  (OnClick)="addNewSubset()">
</app-custom-button>


<app-file-upload-div
  [productName]="productName"
  [fileInfo]="fileInfo"
  (ClickOutSide)="hideUpload($event)">
</app-file-upload-div>
